module.exports = __webpack_public_path__ + "img/serifnew_box13.d1e0a9bf.jpg";